import { useSyncExternalStore } from 'react';

import { MANAGERS, type Manager } from '../../../mock/manager';

/*
 * Заглушка сессии: выбранный менеджер лежит в localStorage.
 *
 * Настоящей аутентификации нет - модель ролей ещё не принята решением, а бэкенд
 * на этой итерации отдаёт справочник без авторизации. Когда появится вход по
 * токену, меняем только этот файл: наружу торчат три функции и хук.
 */

const STORAGE_KEY = 'culture_manager_id';

const listeners = new Set<() => void>();

const notify = () => listeners.forEach((listener) => listener());

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const readManagerId = (): string | null => {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    // Приватный режим или запрет на хранилище: считаем, что сессии нет.
    return null;
  }
};

export const getCurrentManager = (): Manager | null => {
  const id = readManagerId();
  return MANAGERS.find((manager) => manager.id === id) ?? null;
};

export const signIn = (manager: Manager) => {
  try {
    localStorage.setItem(STORAGE_KEY, manager.id);
  } catch {
    // Не смогли сохранить - сессия проживёт до перезагрузки страницы.
  }
  notify();
};

export const signOut = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Нечего чистить.
  }
  notify();
};

/** Текущий менеджер, реактивно: компонент перерисуется на вход и выход. */
export const useCurrentManager = (): Manager | null =>
  useSyncExternalStore(subscribe, getCurrentManager, () => null);
